import { Component } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { RouterModule } from '@angular/router';
import {scrollTo} from '../../../utils/utils';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [SharedModule, PipesModule, RouterModule],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss'
})
export class BannerComponent {


	scrollTo(id: string): void {
		scrollTo(id);
	}

}
